import React from 'react';

import ScribeLink from 'lib/apps/scribe/ScribeLink';

const RightNav = (props) => {
  const { rightNavLink, rightNavLabel } = props;

  if (rightNavLabel && rightNavLink) {
    return (
        <div className="rightNav">
            <div className="hd-topNavigation__button">
                <ScribeLink
                  className="hd-topNavigation_link"
                  to={rightNavLink}
                >
                    {rightNavLabel}
                </ScribeLink>
            </div>
        </div>
    );
  }
  return (null);
};

export default RightNav;
